import type { AppConfigInput } from 'nuxt/schema';

const config: AppConfigInput = {
  ui: {
    colors: {
      primary: 'primary',
      info: 'info',
      success: 'success',
      secondary: 'secondary',
      warning: 'warning',
      neutral: 'neutral',
      error: 'error',
    },
    button: {
      slots: {
        base: 'cursor-pointer',
      },
      variants: {
        variant: {
          link: 'underline',
        },
      },
    },
    selectMenu: {
      slots: {
        base: 'cursor-pointer',
        item: 'cursor-pointer',
      },
      variants: {
        variant: {
          subtle: 'bg-primary/10',
        },
      },
      defaultVariants: {
        variant: 'subtle',
      },
    },
    modal: {
      variants: {
        fullscreen: {
          false: {
            content: 'w-full max-w-2xl',
          },
        },
      },
    },
    formField: {
      slots: {
        error: 'cy-error-class',
      },
    },
  },
};

export default config;
